<template>
  <div id="app">
    <SvgSprite />
    <router-view/>
  </div>
</template>

<style src="@/assets/css/pe-icon-7-stroke.css"></style>

<script src="http://code.jquery.com/jquery-2.2.1.min.js"></script>
<script>
  import SvgSprite from "@/components/common/SvgSprite.vue";

  export default {
    name: 'App',
    components: {
      SvgSprite
    },

    // <!-- from Ads engine for production -->
    // mounted() {
    //   let adsConstantScript = document.createElement("script");
    //   adsConstantScript.setAttribute('type', 'text/javascript');
    //   adsConstantScript.innerHTML = 
    //     'const PUBLISHER_CODE = ' +
    //       '"K8BS15VjFpLc2XTGf4IgObD8PowJue65Q9WovmqJ1e2US0WwnunF9a496QYC2wfDXstrlVWri0FIM7WszYgkTYVBTdG8bP3qlFKNYfmVzoiZvm1KpntVk7idjAXlbCqrUVOi4hqPhhbo8ZGXreUo8q6EAXr0zgZu4FO9zDU3sVh4DwdubrbyKJRLVLAoa8NCluD1bqDxfTy5EuX9f6q8h6OMGxjKHrt6Nus0PmlxqL6AOQXxmxx26puBuDGDKi4";';
    //   document.head.appendChild(adsConstantScript);

    //   let adsScript = document.createElement("script");
    //   adsScript.setAttribute(
    //     "src",
    //     "https://bib-adsengine.com/static/js/cdn.js"
    //   );
    //   document.head.appendChild(adsScript);
    // }
    // <!-- from Ads engine for production -->
    
    // <!-- from Ads engine for staging -->
    // mounted() {
    //   let adsConstantScript = document.createElement("script");
    //   adsConstantScript.setAttribute('type', 'text/javascript');
    //   adsConstantScript.innerHTML = 
    //     'const PUBLISHER_CODE = ' +
    //       '"RBB9bcVvZL3FwJ4qnrdpK3gf2vMrYXmYelUpyIje8n9ny2u5yUUqgHHZyt5RMq8MlgKg3isTrvTykkxfieqQ50ZrF1iOc19k3xmN7oEifSCKw7KcwzljmmstIVVPVsmWul8kSTqlfRGRdEZWFRn1Y0FsEmgML9mu38zlTllwhpEYqBfgCmwR8YUPuY5rASvXCsFJCAsQ8Aq9wmLGqOwuhff9wvdr5htENBlxBhKuhk4cRjtUyYMl5mnmgRDWwtE";';
    //   document.head.appendChild(adsConstantScript);

    //   let adsScript = document.createElement("script");
    //   adsScript.setAttribute(
    //     "src",
    //     "https://bib-adsengine-stg.com/static/js/ads_cdn.js"
    //   );
    //   document.head.appendChild(adsScript);
    // }
    // <!-- from Ads engine for staging -->
  }
</script>
<style>
  /* @import 'https://bib-adsengine.com/static/css/cdn.css'; */
  /* @import 'https://bib-adsengine-stg.com/static/css/ads_cdn.css'; */
</style>

